import { css } from "styled-components";
import styled from "styled-components/macro";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  border-radius: 8px;

  &.search-input {
    max-width: 240px;
  }

  &.text-area-wrapper {
    width: 50%;
  }

  .country-code-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;

    .phone-wrapper {
      width: 50px;
      height: 40x;
    }
  }
`;

export const Label = styled.label`
  color: var(--Neutral-60);
  font-weight: 500;
  display: flex;
  gap: 4px;

  ${(props) =>
    props.size === "S" &&
    css`
      font-size: 10px;
      font-weight: 500;
      line-height: 12px;
      letter-spacing: -0.015px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.018px;
    `}
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-8);
  transition: all 0.2s ease-in-out;
  gap: 6px;

  &.multiple-filter {
    border-radius: 0 24px 24px 0;
    border-left: 0;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid var(--Error-100);

      &:focus-within {
        border: 1px solid var(--Error-100) !important;
      }
    `}

  &.domains-field {
    &:focus-within {
      border: 1px solid var(--Neutral-8);
    }
  }

  &.phone-wrapper-styles {
    flex: 1;
  }

  &.search-input {
    border-radius: 24px;
  }

  ${(props) =>
    props.size === "S" &&
    css`
      height: 32px;
      font-size: 14px;
      padding: 8px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      height: 40px;
      font-size: 16px;
      padding: 10px;
    `}

     ${(props) =>
    !props.disabled &&
    css`
      &:focus-within {
        border: 1px solid var(--Neutral-80);
      }
    `}

     /* Disabled styles */
  ${(props) =>
    props.disabled &&
    css`
      background: var(
        --Neutral-4,
        linear-gradient(
          0deg,
          rgba(31, 31, 31, 0.04) 0%,
          rgba(31, 31, 31, 0.04) 100%
        ),
        #fff
      );
      cursor: not-allowed;
    `}
`;

export const StyledInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: var(--Neutral-100);
  font-weight: 400;

  &.wrap-text {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }

  .country-code-wrapper &::-webkit-outer-spin-button,
  .country-code-wrapper &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .country-code-wrapper &[type="number"] {
    -moz-appearance: textfield;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: var(--Neutral-40);
  }

  ${(props) =>
    props.size === "S" &&
    css`
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.012px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.014px;
    `}
`;

export const IconStyles = styled.span`
  display: flex;
  align-items: center;

  &.right-icon {
    cursor: pointer;
  }

  &.logo-preview-wrapper {
    width: 20px;
    height: 20px;
  }

  img {
    display: block;
    border-radius: 50%;
    object-fit: cover;
  }

  ${(props) =>
    props.size === "S" &&
    css`
      width: 12px;
      height: 12px;

      svg,
      img {
        width: 12px;
        height: 12px;
      }
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      width: 14px;
      height: 14px;

      svg {
        width: 14px;
        height: 14px;
      }

      img {
        width: 20px;
        height: 20px;
      }
    `}
`;

export const HelperText = styled.span`
  color: ${({ hasError, hasWarn }) =>
    hasError
      ? "var(--Error-100)"
      : hasWarn
        ? "var(--warning-100)"
        : "var(--Neutral-40)"};
  font-weight: 400;

  ${(props) =>
    props.size === "S" &&
    css`
      font-size: 10px;
      line-height: 12px;
      letter-spacing: -0.01px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.012px;
    `}
`;

export const StyledTextArea = styled.textarea`
  flex: 1;
  width: 100%;
  box-sizing: border-box; /* important */
  border: none;
  outline: none;
  background: transparent;
  color: var(--Neutral-100);
  font-weight: 400;
  resize: none;
  overflow-y: scroll;
  overflow-x: unset;

  /* custom scrollbar */
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: var(--Neutral-300);
    border: 1px solid transparent;
    background-clip: content-box;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: var(--Neutral-40);
  }

  ${(props) =>
    props.size === "S" &&
    css`
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.012px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.014px;
    `}
`;

export const TextAreaWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid var(--Neutral-8);
  transition: all 0.2s ease-in-out;
  gap: 6px;
  padding: 0;
  height: 100%;

  ${(props) =>
    props.size === "S" &&
    css`
      font-size: 14px;
      padding: 8px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      font-size: 16px;
      padding: 10px;
    `}

     ${(props) =>
    !props.disabled &&
    css`
      &:focus-within {
        border: 1px solid var(--Neutral-80);
      }
    `}

     /* Disabled styles */
  ${(props) =>
    props.disabled &&
    css`
      background: var(
        --Neutral-4,
        linear-gradient(
          0deg,
          rgba(31, 31, 31, 0.04) 0%,
          rgba(31, 31, 31, 0.04) 100%
        ),
        #fff
      );
      cursor: not-allowed;
    `}
`;

export const SelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid var(--Neutral-8);
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  .option-wrapper {
    display: "flex";
    align-items: center;
    gap: 6px;
    padding-left: 10px;
  }

  .select-input-filed {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    padding: 8px 10px;
    cursor: text;
    font-weight: 400;

    &::placeholder {
      color: var(--Neutral-40);
    }
  }

  ${(props) =>
    props.size === "S" &&
    css`
      height: 32px;
      padding: 0 8px 0 0;
      .select-input-filed {
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.012px;
      }
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      height: 40px;
      padding: 0 10px 0 0;
      .select-input-filed {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.014px;
      }
    `}

  ${(props) =>
    props.disabled &&
    css`
      background: var(
        --Neutral-4,
        linear-gradient(
          0deg,
          rgba(31, 31, 31, 0.04) 0%,
          rgba(31, 31, 31, 0.04) 100%
        ),
        #fff
      );
      cursor: not-allowed;
      color: var(--Neutral-40);
    `}

  &.open {
    border: 1px solid var(--Neutral-80);
  }
`;

export const SelectedValue = styled.span`
  flex: 1;
  color: ${(props) =>
    props.isPlaceholder ? "var(--Neutral-40)" : "var(--Neutral-100)"};
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.014px;
`;

export const Dropdown = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 4px;
  border: 1px solid var(--Neutral-8);
  border-radius: 8px;
  background: #fff;
  list-style: none;
  padding: 4px;
  z-index: 9;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 8px;
  background: #fff;
  box-shadow:
    0 110px 31px 0 color(display-p3 0 0 0 / 0),
    0 70px 28px 0 color(display-p3 0 0 0 / 0.01),
    0 40px 24px 0 color(display-p3 0 0 0 / 0.05),
    0 18px 18px 0 color(display-p3 0 0 0 / 0.09),
    0 4px 10px 0 color(display-p3 0 0 0 / 0.1);
  color: var(--Neutral-100);
  font-weight: 400;

  /* custom scrollbar */
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: var(--Neutral-300);
    border: 1px solid transparent;
    background-clip: content-box;
  }

  ${(props) =>
    props.size === "S"
      ? css`
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.012px;
        `
      : css`
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.014px;
        `}
`;

export const Option = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  color: var(--Neutral-100);
  font-weight: 400;

  &.select-checkbox {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &:hover {
    background: var(--Neutral-4);
  }

  ${(props) =>
    props.size === "S"
      ? css`
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.012px;
        `
      : css`
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.014px;
        `}

  ${({ selected, isMulti }) =>
    selected &&
    !isMulti &&
    `
      background: #f0f0f0;
    `}

  /* Custom checkbox style for Select component */
  &.select-checkbox input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background-color: transparent;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease;

    &.disabled-checkbox {
      opacity: 0.5;
    }
  }

  &.select-checkbox input[type="checkbox"]:checked {
    background-color: #1f1f1f;
  }

  &.select-checkbox input[type="checkbox"]:focus {
    outline: none;
    box-shadow: none;
  }

  /* Optional checkmark */
  &.select-checkbox input[type="checkbox"]:checked::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 5px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
